// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading___3GiIY","loading":"loading___3jFUU"};